import styled from 'styled-components'

export const NoTableDataText = styled.p`
    padding: 60px;
    text-align: center;
    margin: 10px;
    font-weight: 700;
    line-height: 1.5;
    font-size: 0.8em;
`